import { createSelector } from 'reselect';

import { getFakeAuthName } from '../service/DevHelpers/DevHelpers';
import { AuthorizationData } from '../typings/common';
import { FakeAuthData } from '../typings/dev';
import { State } from '../typings/state';

export const selectFakeAuthParams = createSelector(
    (state: State) => state.commonData.authorizationData,
    (authorizationData?: AuthorizationData): FakeAuthData | undefined => {
        const fakeName = getFakeAuthName();

        return fakeName && authorizationData
            ? {
                  fakeName,
                  uid: authorizationData.userId
              }
            : undefined;
    }
);
